<template>
    <!-- TODO: Ni el body ni el asserts se guardan al crear un testcase -->
    <section>
        <Sidebar />
        <Content class="create-test-case-page">
            <h1><i class="far fa-file-alt" style="margin-right: 5px;"></i> Test Case logs</h1>

            <b-table
                :data="data"
                ref="table"
                paginated
                per-page="15"
                :opened-detailed="defaultOpenedDetails"
                detailed
                detail-key="id"
                :show-detail-icon="showDetailIcon"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page">

                <template slot-scope="props">
                    <b-table-column label="Response time">
                        {{parseFloat(props.row.response_time)}} ms
                    </b-table-column>

                    <b-table-column field="response_status_code" label="Response status">
                        {{ props.row.response_status_code }}
                    </b-table-column>

                    <b-table-column field="date" label="Date" centered>
                        <small>{{new Date(props.row.created).toLocaleDateString()}}
                        {{new Date(props.row.created).toLocaleTimeString()}}</small>
                    </b-table-column>

                     <b-table-column field="result" label="ID" width="40" numeric>
                        <span class="tag is-success" v-if="props.row.result == 0">PASSED</span>
                        <span class="tag is-danger" v-else-if="props.row.result == 1">TIMEOUT</span>
                        <span class="tag is-danger" v-else-if="props.row.result == 2">ERROR</span>
                        <span class="tag is-danger" v-else-if="props.row.result == 3">FAILED</span>
                    </b-table-column>
                </template>

                <template slot="detail" slot-scope="props">
                    <article class="media">
                        <pre>{{JSON.stringify(props.row.response, null, 2)}}</pre>
                    </article>
                </template>
            </b-table>
        </Content>
    </section>
</template>

<script>
import Sidebar from "../components/sidebar/Sidebar"
import Content from "../components/Content"
import {getCheckTestCase} from "../logic/testcase"

let data = []

export default {
    name: 'TestCaseLogs',
    components: {Sidebar, Content},
    data() {
        return {
            data: data,
            showDetailIcon: true,
            defaultOpenedDetails: [1]
        }
    },
    methods: {
        
    },
    mounted: function(){
        getCheckTestCase(this.$route.params.testcase_id).then(response => {
            console.log(response)
            this.data = response.data.results
        }).catch(error => {

        })
    }
}
</script>

<style scoped>
    h1{margin-bottom: 24px;}
   
</style>